/**
 * Section component used to configure
 * 1FA device access settings.
 *
 * This component handles:
 * - Relay configuration.
 * - Authentication access configuration.
 * - Employee assignment.
 * - Department assignment.
 * - 1FA restriction configuration.
 * - Step cleanup actions.
 *
 * @component SectionCreateDevice1FA
 *
 * @param {Object} props - Component properties.
 * @param {Object} props.data - Device form data.
 * @param {Function} props.handleChange - Updates form field values.
 * @param {Function} props.handleClear - Clears step configuration values.
 * @param {Function} props.setDeviceCustomAccess - Updates assigned employees.
 * @param {Function} props.setDeviceDepartment - Updates assigned departments.
 * @param {Function} props.t - Translation function.
 * @param {number|string|undefined} props.id - Device identifier.
 * @param {Array<number|string>} props.selectForDeleteEmp - Selected employees for deletion.
 * @param {Function} props.setSelectForDeleteEmp - Updates selected employees for deletion.
 * @param {Array<number|string>} props.selectForDeleteDepa - Selected departments for deletion.
 * @param {Function} props.setSelectForDeleteDepa - Updates selected departments for deletion.
 *
 * @returns {JSX.Element} 1FA device configuration section.
 */
import AvailableTabs from "./AvailableTabs";
import DivContainerBody from "../../../../components/DivContainerBody";
import ButtonIcon from "../../../../components/buttons/ButtonIcon";
import {CleanIcon, IconCardRelay, IconCardSettings} from "../../../../components/buttons/IconButtons";
import {AUTHENTICATION_MODEL, STEPS_CREATE_DEVICE} from "../Model/Model";
import React from "react";
import {UserRestrictionItem} from "../../Restrictions/Subcomponents/UserRestrictionItem";
import CustomCard from "../../../../components/CustomCard";

const SectionCreateDevice1FA = ({
                                    data,
                                    handleChange,
                                    handleClear,

                                    setDeviceCustomAccess,
                                    setDeviceDepartment,

                                    t,
                                    id,

                                    selectForDeleteEmp,
                                    setSelectForDeleteEmp,
                                    selectForDeleteDepa,
                                    setSelectForDeleteDepa}) => {
    return (
        <DivContainerBody>
            <div className={"row mb-3"}>
                <div className='d-flex justify-content-end col-12 mb-2'>
                    {id !== undefined ? (
                        ''
                    ) : (
                        <ButtonIcon
                            className='btn-clean-secondary-600'
                            id='btn_cud_clean_all_inputs'
                            Icon={CleanIcon}
                            title={'clear_instances'}
                            onClick={() => {
                                handleClear(STEPS_CREATE_DEVICE.UNOFA.INDEX);
                            }}
                            iconProps='btn-icon-svg-12px icon-color-general-00'
                        />
                    )}
                </div>
                <div className={"row p-0"}>
                    <div className={"col-12 col-md-6"}>
                        <CustomCard classes={'card-border-8px'} classContent='p-0 overflow-hidden'>
                            <div className='d-flex align-items-center p-3'>
                                <div><IconCardRelay /></div>
                                <div className='ml-2'>
                                    <p className={'font-color-general-950 ibl-font-w-600 fs-14px'}>{t('relay_configurations')}</p>
                                </div>
                            </div>
                            <div className={'border-bottom-shades-300'} />
                            <UserRestrictionItem
                                id="cb_e_enable_relay_1_fa"
                                name='enableRelay1FA'
                                title='enable_relay'
                                description='description_enable_relay'
                                checked={data?.unoFa?.enableRelay1FA}
                                onChange={(e) => { handleChange(e, "enableRelay1FA", 'unoFa')}}
                                className={'m-3'}
                            />
                        </CustomCard>
                    </div>
                    <div className={"col-12 col-md-6"}>
                        <CustomCard classes={'card-border-8px'} classContent='p-0 overflow-hidden'>
                        <div className='d-flex align-items-center p-3'>
                            <div><IconCardSettings /></div>
                            <div className='ml-2'>
                                <p className={'font-color-general-950 ibl-font-w-600 fs-14px'}>{t('authentication_access')}</p>
                            </div>
                        </div>
                        <div className={'border-bottom-shades-300'} />
                            <UserRestrictionItem
                                id="cb_e_open_relay_for_all_1_fa"
                                name='openRelayForAll1FA'
                                title='allow_open_access'
                                description='description_allow_open_access'
                                checked={data?.unoFa?.openRelayForAll1FA}
                                onChange={(e) => { handleChange(e, "openRelayForAll1FA", 'unoFa')}}
                                className={"m-3"}
                            />
                        </CustomCard>
                    </div>
                </div>

                { !data?.unoFa?.openRelayForAll1FA &&
                    <div className={"mb-4 mt-4"}>
                        <AvailableTabs authentication={AUTHENTICATION_MODEL.ONE_FA}
                                       id={id}
                                       selectForDeleteEmp={selectForDeleteEmp}
                                       setSelectForDeleteEmp={setSelectForDeleteEmp}

                                       selectForDeleteDepa={selectForDeleteDepa}
                                       setSelectForDeleteDepa={setSelectForDeleteDepa}

                                       setDeviceCustomAccess={setDeviceCustomAccess}
                                       setDeviceDepartment={setDeviceDepartment}/>
                    </div>
                }

            </div>
        </DivContainerBody>
        )
}

export default SectionCreateDevice1FA
